const ENV = process.env.REACT_APP_ENV || 'local';

const getApiBaseUrl = (env) => {
  if (env === 'local') return 'http://localhost:3000';
  if (env === 'production') return 'https://api.receptionist.jp';
  return `https://${env}.api.receptionist.jp`;
};

export default { apiBaseUrl: getApiBaseUrl(ENV) };
